import { useSessionTutorial } from '@/features/session-tutorial/SessionTutorialProvider';
import type { SessionTutorialStepId } from '@/features/session-tutorial/sessionTutorial.types';

/**
 * The control's click handler: while `step` is active, the click completes it instead of doing `action`
 * (e.g. the record button plays the sample consultation rather than recording).
 */
export const useTutorialStepAction = (step: SessionTutorialStepId, action: () => void) => {
  const tutorial = useSessionTutorial();
  return tutorial?.activeStep === step ? () => tutorial.complete(step) : action;
};
